import QRious from 'qrious';

function createQrCode(value, {
  asDataURL = true,
  mimeType = 'image/jpeg',
  size = 100
} = {}) {
  const qrCode = new QRious({ value: value, size: size });
  if (asDataURL) {
    return qrCode.toDataURL(mimeType);
  }
  return qrCode;
}

export { createQrCode };
